import { render, staticRenderFns } from "./Anotador.vue?vue&type=template&id=31222500"
import script from "./Anotador.vue?vue&type=script&lang=js"
export * from "./Anotador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports